import { render, staticRenderFns } from "./ConversationFiles.vue?vue&type=template&id=310d9248&"
import script from "./ConversationFiles.vue?vue&type=script&lang=js&"
export * from "./ConversationFiles.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports